import { Flex, Text } from "@chakra-ui/react";
import { useSelector } from "react-redux";

import FormHeading from "@/components/ui/auth/FormHeading";
import viewsSelectors from "@/store/views/views.selectors";

const defaultViews = ["My Favorite", "Top Priority"];

/**
 * Component for displaying recommended view options
 * @param {Object} props - Component props
 * @param {(title: string) => void} props.setSelectedDefaultTitle - Function to set the selected default title
 * @param {string} props.currentTitle - Currently selected title
 * @param {boolean} props.isView - Whether this is a view or a list
 * @see src/store/views/views.selectors.ts
 * @see src/components/ui/auth/FormHeading.tsx
 */
const RecomendedViews = ({ 
  setSelectedDefaultTitle, 
  currentTitle, 
  isView 
}: { 
  setSelectedDefaultTitle: (title: string) => void; 
  currentTitle: string; 
  isView: boolean 
}) => {
  const views = useSelector(viewsSelectors.getViews());
  const viewsTitle = views?.map((item: any) => item?.title);
  const defViews = defaultViews?.filter((item: string) => !viewsTitle?.includes(item));

  return (
    <>
      {defViews?.length ? (
        <Flex direction={"column"} rowGap={"4px"}>
          <FormHeading
            title={`Or use ${defViews?.length < 2 ? "this" : "these"}:`}
            content=""
            styles={{ fontSize: "12px", textAlign: "start" }}
            wrapStyles={{ mb: "0" }}
          />
          <Flex align={"center"} columnGap={"4px"}>
            {defViews?.map((item, idx) => (
              <Flex
                key={idx}
                align={"center"}
                justify={"center"}
                w={"100%"}
                maxW={"98px"}
                bg={
                  currentTitle === item
                    ? "mainBlue"
                    : isView
                    ? "lightBlue2"
                    : "lightGreen2"
                }
                color={currentTitle === item ? "white" : "mainBlue"}
                _hover={{ bg: "mainBlue", color: "white" }}
                borderRadius={"4px"}
                h={"26px"}
                py={"6px"}
                cursor={"pointer"}
                onClick={() => setSelectedDefaultTitle(item)}
              >
                <Text
                  mt={"3px"}
                  fontSize={"14px"}
                  letterSpacing={"2%"}
                  lineHeight={"1"}
                  fontWeight={400}
                >
                  {item}
                </Text>
              </Flex>
            ))}
          </Flex>
        </Flex>
      ) : null}
    </>
  );
};

export default RecomendedViews;
